import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import GridDataPackages from '../components/gridmodal/GridDataPackages';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import ImplementSetupRightFilterToggle from '../components/ImplementSetupRightFilterToggle';
import { ValidDate, formatNumnberWithComma, formatDate } from '../components/Utlities';


export default function ImplementationReport() {

    const [StatusBills, setStatusBills] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        { criKey: 3, criValue: 'Transportation Provider' },
        // { criKey: 4, criValue: 'Freight Bill Number' },
        { criKey: 5, criValue: 'Transportation Provider Account Number' }
    ];

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const searchOnClick = (selectedOwner, selectedCust, selectedLocationType, selectedLocationName, selectedServiceType, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus) => {
        LoadSummaryData(selectedOwner, selectedCust, selectedLocationType, selectedLocationName, selectedServiceType, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus);
    }

    const LoadSummaryData = async (selectedOwner, selectedCust, selectedLocationType, selectedLocationName, selectedServiceType, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus) => {
        debugger;
        setLoading(true);
        setStatusBills([]);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetImplementationReport/${selectedOwner}/` +
            `${selectedCust}/${selectedLocationType}/${selectedLocationName}/${selectedServiceType}/` +
            `${selectedFundingType}/${selectedContractCompleted}/${selectedServiceRegion}/${selectedImplementationStatus}`;

        console.log(URL);
        await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                // Convert 'contractDate' to formatted string in the response
                const modifiedResponse = resp.map(item => ({
                    ...item,
                    projectedVolume: formatNumnberWithComma(item.projectedVolume),
                    projectedVolumeSpend: formatNumnberWithComma(item.projectedVolumeSpend)
                }));

                setStatusBills(modifiedResponse);
                console.log(modifiedResponse);
            });
        setLoading(false);
    };


    const columns = [
        {
            dataField: 'id',
            text: 'Id',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'ownerName',
            text: 'Owner',
            headerStyle: { width: '120px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'customerName',
            text: 'Customer',
            headerStyle: { width: '150px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'locationTypeName',
            text: 'Location Type',
            headerStyle: { width: '80px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'locationDesc',
            text: 'Location Name',
            headerStyle: { width: '180px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'serviceTypeDesc',
            text: 'Type of Service',
            headerStyle: { width: '125px', textAlign: 'center' },
            hidden: false,
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'fundingTypeDesc',
            text: 'Funding Type',
            headerStyle: { width: '80px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'salesPerson',
            text: 'Sales Person',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'left',
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'contractCompletedDesc',
            text: 'Contract Completed',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'contractDateString',
            text: 'Contract Date',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'projectedVolume',
            text: 'Projected Freight Bill Volume',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'projectedVolumeSpend',
            text: 'Projected Freight Spend Volume',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'serviceRegionDesc',
            text: 'Region of nVision Service',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'implementationStartDateString',
            text: 'Implementation Start Date',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'projectedProductionDateString',
            text: 'Projected Production Date',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'actualProductionDateString',
            text: 'Actual Production Date',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'left',
            sort: true
        }
    ];



    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: StatusBills.length
        }]
    };

    const detailOptions = {
        sizePerPageRenderer,
        sizePerPageList: [
            {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: 'All', value: DetailByCustCarr.length
            }
        ]


    };

    //to export report logic
    const DownloadSummaryData = async () => {
        const URL = `${configData.BASE_APP_URL}Implementaion/GenerateExcelForImplementationReport`;
        // console.log(URL);

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: StatusBills }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Implementation Report.xlsx`;
        link.click();
    };


    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Implementation Report' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>
                        {/* <Breadcrumbs title="Invoice Status (Freight Bill Status Report)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        {/* <div className='sticky-top-content'>
                            <TopFilter oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} />
                        </div> */}
                        <div className='d-flex'>
                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {StatusBills.length > 0 ?
                                            <ToolkitProvider
                                                keyField="id"
                                                data={StatusBills}
                                                columns={columns}
                                                exportCSV={{ fileName: 'Implementation Report.csv' }}>
                                                {
                                                    props => (
                                                        <div>
                                                            {/* <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: 'right' }}>
                                                                <ExportCSVButton {...props.csvProps} ><i className='fa fa-download'></i> Export </ExportCSVButton>
                                                            </div> */}
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />

                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}
                                    </div>
                                </div>
                            </div>
                            <ImplementSetupRightFilterToggle onSearchClick={searchOnClick} />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}